import { render, staticRenderFns } from "./TermsListForm.vue?vue&type=template&id=7c5a36b2&scoped=true&"
import script from "./TermsListForm.vue?vue&type=script&lang=js&"
export * from "./TermsListForm.vue?vue&type=script&lang=js&"
import style0 from "./TermsListForm.vue?vue&type=style&index=0&id=7c5a36b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a36b2",
  null
  
)

export default component.exports